import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../../toastify/config";
import apiSafibc from "../../../axios/axios";

const CapitulosPreview = () => {




    /*const capitulosLibro = [
        {
            id: 1,
            titulo: "El estrés financiero también enferma",
            resumen: "Carlos se despierta todos los días con el despertador antes de que salga el sol...",
            slug: "estres-financiero"
        },
        {
            id: 2,
            titulo: "Trabajar mucho y avanzar poco",
            resumen: "No todo el cansancio es igual. Existe el cansancio sano, ese que aparece después...",
            slug: "trabajar-avanzar"
        },
        {
            id: 3,
            titulo: "Hábitos diarios que te roban energía y dinero",
            resumen: "Un café aquí, una comida rápida allá, un antojo después de un día pesado. Nada de...",
            slug: "habitos-diarios"
        },
        {
            id: 4,
            titulo: "Señales de alerta de una mala salud financiera",
            resumen: "Vivir con estrés constante, preocuparte cada semana por el dinero o sentir...",
            slug: "alerta-mala"
        },
        {
            id: 5,
            titulo: "Sistema respiratorio financiero: el flujo de efectivo",
            resumen: "Aguantar la respiración no es respirar. Sobrevivir con el dinero justo...",
            slug: "respiratorio-financiero"
        },
        {
            id: 6,
            titulo: "Sistema digestivo financiero: cómo procesas tu dinero",
            resumen: "Hay personas con ingresos modestos que viven con estabilidad y tranquilidad...",
            slug: "digestivo-financiero"
        },
        {
            id: 7,
            titulo: "Sistema cardiovascular financiero: las deudas",
            resumen: "Existen deudas que impulsan crecimiento y otras que solo consumen energía...",
            slug: "digestivo-financiero"
        },
        {
            id: 8,
            titulo: "Sistema muscular financiero: el ahorro y la fuerza",
            resumen: "Muchas personas creen que la fortaleza financiera viene de un gran ingreso...",
            slug: "digestivo-financiero"
        },
        {
            id: 9,
            titulo: "Sistema nervioso financiero: decisiones y emociones",
            resumen: "Después de un día largo, tu cerebro no quiere analizar, quiere descanso...",
            slug: "digestivo-financiero"
        },
        {
            id: 10,
            titulo: "Alimentarte mejor sin gastar más",
            resumen: "Comida rápida, ultraprocesados y bebidas azucaradas parecen económicas, pero...",
            slug: "digestivo-financiero"
        },
        {
            id: 11,
            titulo: "Movimiento mínimo, resultados reales",
            resumen: "No moverte lo suficiente no solo afecta tu cuerpo, también afecta tus finanzas...",
            slug: "digestivo-financiero"
        },
        {
            id: 12,
            titulo: "Dormir, respirar y bajar el estrés",
            resumen: "Vivir cansado se vuelve tan común que se normaliza. Te acostumbras a dormir...",
            slug: "digestivo-financiero"
        },
        {
            id: 13,
            titulo: "El plan de 30 días de salud financiera y física",
            resumen: "Antes de empezar, ten claras estas reglas...",
            slug: "digestivo-financiero"
        },
        {
            id: 14,
            titulo: "Hábitos que sostienen el cambio",
            resumen: "Habrá semanas pesadas, gastos inesperados, cansancio, enfermedades...",
            slug: "digestivo-financiero"
        },
        {
            id: 15,
            titulo: "Cómo prevenir recaídas financieras y físicas",
            resumen: "Rara vez una recaída ocurre de golpe. Casi siempre se anuncia con señales...",
            slug: "digestivo-financiero"
        },
    ];*/

    //ver la forma de que sea solo un layout y mandar slug para que se genere la ruta temporal
    //y en ese layout global de capitulo poder mandar el diseno que llevaria, pero no crear otro componente por capitlo

    const [capitulosLibro, setCapitulosLibro] = useState([])
    const obtenerCapitulosLibro = () => {

        const capLibros = async () => {
            try {

                const capitulos = await apiSafibc('/blog/obtener-capitulos')

                setCapitulosLibro(capitulos.data)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al generar articulo, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }
        }

        capLibros()
    }

    useEffect(() => {
        obtenerCapitulosLibro()
    }, [])

    return (
        <section className="blog-capitulos">
            <h2>Capítulos del libro</h2>

            <div className="blog-capitulos__grid">
                {capitulosLibro.map((cap) => (
                    <div key={cap.id_capitulo_blog} className="capitulo-card">
                        <span className="capitulo-num">{cap.capextra ? cap.capextra : `Capítulo ${cap.capitulo}`}</span>
                        <h3>{cap.titulo}</h3>
                        <p>{cap.resumen}</p>

                        <Link to={`/libro/capitulo/${cap.slug}`} className="capitulo-link">
                            Leer resumen →
                        </Link>
                    </div>
                ))}
            </div>

            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
        </section>
    );
};

export default CapitulosPreview;

